import { render, staticRenderFns } from "./vias.vue?vue&type=template&id=1ce1ae56&scoped=true"
import script from "./vias.vue?vue&type=script&lang=js"
export * from "./vias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce1ae56",
  null
  
)

export default component.exports